
import { Box } from '@mui/system';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, ListContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import { useState } from 'react';
import styled from '@emotion/styled'
import { Input, Radio } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { alertPageName } from '../components/PageName';
import { useTranslation } from "react-i18next";

/**
 * CSS Styles
 */
const NameSpan = styled.span`
    font-size: calc(12px + 0.4vw);
    display: inline-block;
    width: calc(50px + 3vw);
`
const NamesContainer = styled.div`
    width: calc(200px + 36vw);
    display: flex;
    justify-content: flex-end;
    font-family: Sofia Sans;
    font-weight: 400;
    text-align: center;
    margin-left: calc(22px + 0.4vw);
    padding-right: calc(32px + 0.4vw);
`

const ListItemsContainer = styled.div`
    width: calc(200px + 36vw);
    background: white;
    padding-top: 11px;
    padding-left: calc(2px + 0.4vw);
    padding-right: calc(32px + 0.4vw);
    margin-left: calc(22px + 0.4vw);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
`

const NumberInput = styled.input`
    font-family: Poppins;
    font-size: calc(13px + 0.1vw);
    width: 50px;
    margin-left: 27px;
    margin-right: 28px;
    height: 35px;
    border-radius: 10px;
    text-align: center;
`

const ListItemStyleContainer = styled(Box)`
    padding-left: 10px;
    padding-top: 6px;
`

const AlertDescription = styled.span`
    font-family: Poppins;
    font-size: calc(12px + 0.4vw);
    display: inline-block;
`
const AlertDescription2 = styled.span`
    font-family: Poppins;
    font-size: calc(12px + 0.4vw);
    display: inline-block;
`

const AlertLevel = styled.div`
    width: fit-content;
    float: right;
`

const ButtonsBox = styled.div`
    margin-top: 156px;
`

/**
 * Reusable Component
 */
const ListItem = function (props: { description1: string, description2: string, level: number, setLevel: any, isActive: boolean, setIsActive: any }) {
    enum RadiobuttonValues {
        Active = "active",
        Inactive = "inactive"
    }
    
    const computedContainerStyle = function () {
        if (props.description2 == 'Over') {
            return {
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px',
                background: 'rgba(139, 176, 219, 0.2)'
            }
        } else if (props.description2 == 'under') {
            return {
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                marginBottom: '10px',
                background: 'rgba(139, 176, 219, 0.2)'
            }
        } else {
            return {
                background: 'white'
            }
        }
    }

    function radiobuttonOnChanged(event: React.ChangeEvent<HTMLInputElement>) {
        switch (event.target.value) {
            case RadiobuttonValues.Active:
                props.setIsActive(true)
                break;
            case RadiobuttonValues.Inactive:
                props.setIsActive(false)
                break;
            default:
                console.error('unknown radio button value')
        }
    }

    return (
        <ListItemStyleContainer sx={computedContainerStyle()}>
            <AlertDescription>{props.description1}</AlertDescription>
            <AlertLevel>
                <AlertDescription2>{props.description2}</AlertDescription2>
                <NumberInput type="number" min={0} value={props.level} onChange={(event) => props.setLevel(event.target.value)} />
                <Radio
                    checked={props.isActive}
                    onChange={radiobuttonOnChanged}
                    value={RadiobuttonValues.Active}
                    sx={{
                        color: '#000000',
                        '&.Mui-checked': {
                            color: '#000000',
                        },
                        width: 'calc(50px + 3vw)',
                        padding: 0
                    }}
                />
                <Radio
                    checked={!props.isActive}
                    onChange={radiobuttonOnChanged}
                    value={RadiobuttonValues.Inactive}
                    sx={{
                        color: '#000000',
                        '&.Mui-checked': {
                            color: '#000000',
                        },
                        width: 'calc(50px + 3vw)',
                        padding: 0
                    }}
                />
            </AlertLevel>
        </ListItemStyleContainer>
    )
}

/**
 * Page
 */
const AlertSettingPage = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    /**C02 */
    const [levelOfCO2Alert, setLevelOfCO2Alert] = useState(0)
    const [isActiveCO2Alert, setIsActiveOfCO2Alert] = useState(true)

    /**02 */
    const [levelOfO2Alert, setLevelOfO2Alert] = useState(0)
    const [isActiveO2Alert, setIsActiveO2Alert] = useState(true)

    /**CH42 */
    const [levelOfCH4Alert, setLevelOfCH4Alert] = useState(0)
    const [isActiveCH4Alert, setIsActiveCH4Alert] = useState(true)

    /**LEL */
    const [levelOfLELAlert, setLevelOfLELAlert] = useState(0)
    const [isActiveLELAlert, setIsActiveLELAlert] = useState(true)

    /**H2S */
    const [levelOfH2SAlert, setLevelOfH2SAlert] = useState(0)
    const [isActiveH2SAlert, setIsActiveH2SAlert] = useState(true)

    /**Co */
    const [levelOfCoAlert, setLevelOfCoAlert] = useState(0)
    const [isActiveCoAlert, setIsActiveCoAlert] = useState(true)

    /**PM2.5 */
    const [levelOfPMTwoPointFiveAlert, setLevelOfPMTwoPointFiveAlert] = useState(0)
    const [isActivePMTwoPointFiveAlert, setIsActivePMTwoPointFiveAlert] = useState(true)

    /**Environment Temperature */
    const [levelOfEnvironmentTemperatureAlert, setLevelOfEnvironmentTemperatureAlert] = useState(0)
    const [isActiveEnvironmentTemperatureAlert, setIsActiveEnvironmentTemperatureAlert] = useState(true)

    /**Heart Rate Over */
    const [levelOfMaximumHeartRateAlert, setLevelOfMaximumHeartRateAlert] = useState(0)
    const [isActiveMaximumHeartRateAlert, setIsActiveMaximumHeartRateAlert] = useState(true)

    /**Heart Rate under */
    const [levelOfMinimumHeartRateAlert, setLevelOMinimumHeartRateAlert] = useState(0)
    const [isActiveMinimumHeartRateAlert, setIsActiveMinimumHeartRateAlert] = useState(true)

    /**Body Temperature Over*/
    const [levelOfMaximumBodyTemperatureAlert, setLevelOfMaximumBodyTemperatureAlert] = useState(0)
    const [isActiveMaximumBodyTemperatureAlert, setIsActivelMaximumBodyTemperatureAlert] = useState(true)

    /**Body Temperature under*/
    const [levelOfMinimumBodyTemperatureAlert, setLevelOfMinimumBodyTemperatureAlert] = useState(0)
    const [isActiveMinimumBodyTemperatureAlert, setIsActivelMinimumBodyTemperatureAlert] = useState(true)

    function cancel() {
        // navigate("/dashboard")
    }

    function save() {
        alert("Coming soon.")
    }

    return (
        <MainContent type={alertPageName}>
            <BackgroundStyle>
                <ListContainer>
                    <BigHeading>{t("Edit Alert")}</BigHeading>

                    <NamesContainer>
                        <NameSpan>
                            {t("Level")}
                        </NameSpan>
                        <NameSpan>
                            {t("Active")}
                        </NameSpan>
                        <NameSpan>
                            {t("InActive")}
                        </NameSpan>
                    </NamesContainer>

                    {/* Alert Settings*/}
                    <ListItemsContainer>
                        <ListItem
                            description1={t("CO2")}
                            description2=''
                            level={levelOfCO2Alert}
                            setLevel={setLevelOfCO2Alert}
                            isActive={isActiveCO2Alert}
                            setIsActive={setIsActiveOfCO2Alert}
                        />
                        <ListItem
                            description1={t("O2")}
                            description2=''
                            level={levelOfO2Alert}
                            setLevel={setLevelOfO2Alert}
                            isActive={isActiveO2Alert}
                            setIsActive={setIsActiveO2Alert}
                        />
                        <ListItem
                            description1={t("CH4")}
                            description2=''
                            level={levelOfCH4Alert}
                            setLevel={setLevelOfCH4Alert}
                            isActive={isActiveCH4Alert}
                            setIsActive={setIsActiveCH4Alert}
                        />
                        <ListItem
                            description1={t("LEL")}
                            description2=''
                            level={levelOfLELAlert}
                            setLevel={setLevelOfLELAlert}
                            isActive={isActiveLELAlert}
                            setIsActive={setIsActiveLELAlert}
                        />
                        <ListItem
                            description1={t("H2S")}
                            description2=''
                            level={levelOfH2SAlert}
                            setLevel={setLevelOfH2SAlert}
                            isActive={isActiveH2SAlert}
                            setIsActive={setIsActiveH2SAlert}
                        />
                        <ListItem
                            description1={t("CO")}
                            description2=''
                            level={levelOfCoAlert}
                            setLevel={setLevelOfCoAlert}
                            isActive={isActiveCoAlert}
                            setIsActive={setIsActiveCoAlert}
                        />
                        <ListItem
                            description1={t("PM2.5")}
                            description2=''
                            level={levelOfPMTwoPointFiveAlert}
                            setLevel={setLevelOfPMTwoPointFiveAlert}
                            isActive={isActivePMTwoPointFiveAlert}
                            setIsActive={setIsActivePMTwoPointFiveAlert}
                        />
                        <ListItem
                            description1={t("Environment Temperature")}
                            description2=''
                            level={levelOfEnvironmentTemperatureAlert}
                            setLevel={setLevelOfEnvironmentTemperatureAlert}
                            isActive={isActiveEnvironmentTemperatureAlert}
                            setIsActive={setIsActiveEnvironmentTemperatureAlert}
                        />
                        <ListItem
                            description1={t("Heart Rate")}
                            description2={t("Over")}
                            level={levelOfMaximumHeartRateAlert}
                            setLevel={setLevelOfMaximumHeartRateAlert}
                            isActive={isActiveMaximumHeartRateAlert}
                            setIsActive={setIsActiveMaximumHeartRateAlert}
                        />
                        <ListItem
                            description1=''
                            description2={t("Under")}
                            level={levelOfMinimumHeartRateAlert}
                            setLevel={setLevelOMinimumHeartRateAlert}
                            isActive={isActiveMinimumHeartRateAlert}
                            setIsActive={setIsActiveMinimumHeartRateAlert}
                        />
                        <ListItem
                            description1={t("Body Temperature")}
                            description2={t("Over")}
                            level={levelOfMaximumBodyTemperatureAlert}
                            setLevel={setLevelOfMaximumBodyTemperatureAlert}
                            isActive={isActiveMaximumBodyTemperatureAlert}
                            setIsActive={setIsActivelMaximumBodyTemperatureAlert}
                        />
                        <ListItem
                            description1=''
                            description2={t("Under")}
                            level={levelOfMinimumBodyTemperatureAlert}
                            setLevel={setLevelOfMinimumBodyTemperatureAlert}
                            isActive={isActiveMinimumBodyTemperatureAlert}
                            setIsActive={setIsActivelMinimumBodyTemperatureAlert}
                        />
                    </ListItemsContainer>

                    {/* Buttons */}
                    <ButtonsBox>
                        <ShortBlueButton onClick={save}>{t("Save")}</ShortBlueButton>
                        <BackButton onClick={cancel}>Cancel</BackButton>
                    </ButtonsBox>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};

export default AlertSettingPage;